<template>
  <div id="test-payment-modal" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <div class="tab-payment-contents">
            <el-row>
              <el-col :span="24">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.cardNo") }}</label>
                  </div>
                  <el-input v-model="form.cardNumber" :class="$inputError('cardNumber', validationErrors)" v-mask="'####-####-####-####'" :placeholder="'####-####-####-####'"></el-input>
                </div>
              </el-col>
              <el-col :span="24" class="mt-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.nameSurname") }}</label>
                  </div>
                  <el-input v-model="form.cardHolderName" :class="$inputError('cardHolderName', validationErrors)" placeholder="John Doe"></el-input>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8" class="mt-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.month") }}</label>
                  </div>
                  <el-input v-model="form.expireMonth" :class="$inputError('expireMonth', validationErrors)" v-mask="'##'" placeholder="12"></el-input>
                </div>
              </el-col>
              <el-col :span="8" class="mt-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.year") }}</label>
                  </div>
                  <el-input v-model="form.expireYear" :class="$inputError('expireYear', validationErrors)" v-mask="'####'" placeholder="2025"></el-input>
                </div>
              </el-col>
              <el-col :span="8" class="mt-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.cvv") }}</label>
                  </div>
                  <el-input v-model="form.cvvCode" v-mask="'####'" :class="$inputError('cvvCode', validationErrors)" placeholder="333"></el-input>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>
    </transition>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'tryPayment'" :disabled="loading == 'tryPayment'" @click="tryPayment">{{ $t("event.table.try") }}</el-button>
      </div>
      <div id="hidden" style="display:none;"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["paymentPosId"],
  data() {
    return {
      loading: false,
      timeout: null,
      form: {
        posId: null,
        cardHolderName: null,
        cardNumber: null,
        expireMonth: null,
        expireYear: null,
        cvvCode: null,
        returnUrl: null
      },
      validationErrors: [],
      threedHtml: null
    };
  },
  methods: {
    async tryPayment() {
      this.loading = "tryPayment";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.form.cardNumber != null) {
          this.form.cardNumber = this.form.cardNumber.replaceAll("-", "");
        }
        var res = await this.$store.dispatch("tryPaymentMethod", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          window.jQuery("#hidden").html(res.data.data.htmlFormContent);
          window
            .jQuery("#hidden")
            .find("form")
            .submit();
        }
        this.loading = false;
      }, 500);
    }
  },
  created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (this.paymentPosId != null && this.paymentPosId != undefined) {
        this.form.posId = this.paymentPosId;
        this.form.returnUrl = location.protocol + "//" + location.host + this.$route.path;
      } else {
        this.$emit("closeDialog");
      }
      this.loading = false;
    }, 500);
  }
};
</script>

<style lang="less">
.tab-payment-contents {
  & > .el-col {
    margin-bottom: 1rem;
  }
  .el-input-number {
    width: 100%;
  }
  .registerform-input-container {
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
        margin-top: 1rem;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      height: 120px;
      .el-icon-upload {
        font-size: 30px;
        margin: 0;
      }
    }
  }
  .packet-head {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 10px;
    font-weight: bold;
  }
}
.add-update-packet-dialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.add-update-packet-dialog-container {
  .bottom {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
}

.add-pricing-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.input-new-tag {
  width: 100px;
}
.photo-walls {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .photo-item {
    position: relative;
    .photo-delete-icon {
      position: absolute;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        color: white;
        font-size: 12px;
      }
      border-radius: 50%;
      background-color: red;
      cursor: pointer;
      right: -0.2rem;
      top: -0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/testPaymentModal.vue